import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@/components/modal/modal";

import ExternalCollabThemes from "components/Collaboration/ExternalCollab/ExternalCollabThemes";
import ExternalCollabLinks from "components/Collaboration/ExternalCollab/ExternalCollabLinks.tsx";
import { hideModal } from "actions/modal";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { deleteSearchParamWhenCloseModal } from "libs/modals/init";
import { MODAL_NAMES } from "constants/Modals";
import { useApprovalExternalData } from "pages/approvals/approval-queries";
import { getUser } from "selectors/commonSelectors";
import { hasExternalApprovals } from "utils/feature-gates";

const ExternalCollabModal = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const { isLoading } = useApprovalExternalData();
  const [saveButtonHidden, setSaveButtonHidden] = useState(false);

  if (!hasExternalApprovals(user)) return null;

  return (
    <Modal
      data-testid="externalCollabModal"
      show={true}
      onHide={() => {
        deleteSearchParamWhenCloseModal(MODAL_NAMES.EXTERNAL_REVIEW);
        dispatch(hideModal());
      }}
      animation={false}
      bsStyle="giselle"
      bsSize="lg"
      className="external-collab-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>External review settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && (
          <div className="flex justify-center mt-10">
            <Spinner size="lg" />
          </div>
        )}
        {!isLoading && (
          <div>
            <div className="mb-20">
              <ExternalCollabThemes />
            </div>
            <div css={{ marginBottom: "10px" }}>
              <ExternalCollabLinks
                onEditStateChange={(isEditing) =>
                  setSaveButtonHidden(isEditing)
                }
              />
            </div>
            {!saveButtonHidden && (
              <div className="flex justify-end">
                <Button
                  variant="blue-primary"
                  size="md"
                  onClick={() => dispatch(hideModal())}
                >
                  Save
                </Button>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

ExternalCollabModal.propTypes = {
  post: PropTypes.object,
};

export default ExternalCollabModal;
